"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTreeFilterAndOrder = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var use_local_storage_state_1 = __importDefault(require("use-local-storage-state"));
var shared_1 = require("./shared");
var transifex_1 = require("../../transifex");
__exportStar(require("./Simple"), exports);
/**
 * Hook: useTreeFilterAndOrder
 * Note:
 * 1. Init.order should include all the columns that you want to show on the table.
 * If any column is not in this list then it will not be rendered.
 */
var useTreeFilterAndOrder = function (_a) {
    var init = _a.init, key = _a.key, columns = _a.columns, popover = _a.popover, _b = _a.hideColumns, hideColumns = _b === void 0 ? [] : _b;
    /* Transifex */
    var _c = react_1.useState(false), initialized = _c[0], setInitialized = _c[1];
    var _d = use_local_storage_state_1.default("useTreeFilterAndOrder.check." + key, init.checked), checkedCols = _d[0], setCheckedCols = _d[1];
    var _e = use_local_storage_state_1.default("useTreeFilterAndOrder.order." + key, init.order), orderCols = _e[0], setOrderCols = _e[1];
    /* Effect -> Clean any column stored in localStorage that is no longer in the init. */
    react_1.useEffect(function () {
        /* Why we want this.
        1. We save the state in localStorage.
        2. This effects make sure that if we remove or change the init state then we clean the localStorage.
        3. The change is only limited to the add/removal of a key and not the order.
        */
        var isOutdated = orderCols.length !== init.order.length ||
            orderCols.some(function (savedKey) { return init.order.indexOf(savedKey) === -1; });
        if (isOutdated) {
            setCheckedCols(init.checked);
            setOrderCols(init.order);
        }
        setInitialized(true);
        // always on mount only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleChangeTableColumnsOrder = react_1.useCallback(
    // eslint-disable-next-line consistent-return
    function (colkey, position) {
        var newDropPosition = position;
        if (position < 0) {
            newDropPosition = 0;
        }
        var cList = __spreadArray([], orderCols);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var currentPosition = cList.findIndex(function (s) { return s === colkey; });
        if (newDropPosition > currentPosition) {
            newDropPosition -= 1;
        }
        if (currentPosition === -1) {
            return null;
        }
        shared_1.arraymove(cList, currentPosition, newDropPosition);
        setOrderCols(cList.filter(Boolean));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [orderCols]);
    var handleAllColsSelected = function (checked) {
        if (checked) {
            setCheckedCols(init.order);
        }
        else {
            setCheckedCols([]);
        }
    };
    return {
        state: initialized
            ? orderCols.map(function (c) { return c; }).filter(function (k) { return checkedCols.includes(k); })
            : [],
        jsx: {
            toggler: (react_1.default.createElement(antd_1.Popover, __assign({}, (popover || {}), { placement: (popover === null || popover === void 0 ? void 0 : popover.placement) || "bottomRight", title: initialized && (react_1.default.createElement(antd_1.Checkbox, { onChange: function (e) { return handleAllColsSelected(e.target.checked); }, indeterminate: !!checkedCols.length &&
                        checkedCols.length !== init.order.length, checked: checkedCols.length === init.order.length }, transifex_1.TX_DISPLAY_COLUMNS)), content: react_1.default.createElement(antd_1.Row, null, initialized && (react_1.default.createElement(shared_1.StyledTree, { draggable: true, checkable: true, checkedKeys: checkedCols, onCheck: function (keys) { return setCheckedCols(keys); }, treeData: orderCols === null || orderCols === void 0 ? void 0 : orderCols.filter(function (k) { return !hideColumns.includes(k); }).map(function (k) { return columns[k]; }), onDrop: function (_a) {
                        var dropPosition = _a.dropPosition, dropNodeKey = _a.dragNode.key;
                        handleChangeTableColumnsOrder(dropNodeKey, dropPosition);
                    } }))) }),
                react_1.default.createElement(antd_1.Button, { type: "text", shape: "circle", icon: react_1.default.createElement(icons_1.SettingOutlined, null) }))),
        },
    };
};
exports.useTreeFilterAndOrder = useTreeFilterAndOrder;
